/* Copyright Information: Created by BuyGroup */
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./assets/scss/app.scss";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store/index";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
/* Copyright Information: Created by BuyGroup */